export default __webpack_public_path__ + "static/collecton02-cbd9794e87b9992de5a9c767af52fa4c.jpg";